<script setup>
import { onMounted } from 'vue';
import { useUsuarioStore } from '@/store/usuarioStore';
import { useListadosEntidadesStore } from '@/store/listadosEntidadesStore';

const usuarioStore = useUsuarioStore();
const listadosEntidadesStore = useListadosEntidadesStore();

const perfil = usuarioStore.user.perfil;

onMounted(async () => {
  try {
    await usuarioStore.getSession();
    await listadosEntidadesStore.getProvincias();
  } catch (error) {
    console.error("Error al cargar el usuario:", error);
  }
});

const opcionesComoNosConocieron = [
  { id: 1, nombre: "Publicidad en redes sociales" },
  { id: 2, nombre: "Recomendación de un amigo" },
  { id: 3, nombre: "Búsqueda en Google" },
  { id: 4, nombre: "Email o Newsletter" },
  { id: 5, nombre: "Otro" }
];



</script>


<template>
  <div class="container mx-auto p-5">
    <!-- Título -->
    <h1 class="fs-2 fw-bold text-center mb-4">Perfil</h1>

    <div class="card p-5 shadow-sm rounded-3">
      <div class="row align-items-center mb-4">
        <div class="col-auto">
          <div class="avatar-container">
            <div class="rounded-circle bg-light d-inline-flex align-items-center justify-content-center avatar"
              style="width: 150px; height: 150px;">
              <span class="fs-2 fw-bold">L G</span>
            </div>
            <div class="avatar-icon">
              <i class="bi bi-camera"></i>
            </div>
          </div>
        </div>

        <div class="col">
          <h2 class=" fw-bold mb-1">Hola, {{ perfil.name }}</h2>
          <p class="text-muted mb-0">Luciano Nahuel Gimenez Ausfet</p>
          <p class="text-muted">ID {{ perfil.id }}</p>
        </div>
      </div>

      <hr>

      <div class="row mt-4">
        <div class="col-md-6">
          <h3 class="fw-bold mb-3">Datos personales</h3>

          <div class="row">
            <div class="col-6 mb-3">
              <label class="form-label">Nombre</label>
              <input type="text" class="form-control" v-model="perfil.name">
            </div>
            <div class="col-6 mb-3">
              <label class="form-label">Apellido</label>
              <input type="text" class="form-control" v-model="perfil.lastname" value="Gimenez Ausfet">
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Alias</label>
            <input type="text" class="form-control" v-model="perfil.razon_social">
          </div>

          <div class="mb-3">
            <label class="form-label">Contraseña</label>
            <div class="d-flex">
              <input type="password" class="form-control me-2" v-model="usuarioStore.user.password">
              <a href="#" class="text-primary text-decoration-none">Crear contraseña</a>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">ID</label>
            <input type="text" class="form-control" v-model="perfil.id" disabled>
          </div>

          <div class="mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" v-model="perfil.email">
          </div>

          <div class="mb-3">
            <label class="form-label">¿Cómo te enteraste de Adrián Mercado?</label>
            <select class="form-select" v-model="perfil.como_nos_conocieron_id">
              <option v-for="opcion in opcionesComoNosConocieron" :key="opcion.id"
                :value="opcion.id">
                {{ opcion.nombre }}
              </option>
            </select>
          </div>

        </div>

        <!-- Datos de Facturación -->
        <div class="col-md-6">
          <h3 class=" fw-bold mb-3">Datos de facturación</h3>

          <div class="mb-3">
            <label class="form-label">CUIT / CUIL</label>
            <input type="text" class="form-control" v-model="perfil.cuit">
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">Teléfono celular</label>
              <input type="text" class="form-control" v-model="perfil.celular">
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Dirección</label>
            <input type="text" class="form-control" v-model="perfil.direccion">
          </div>

          <div class="row">
            <div class="col-6 mb-3">
              <label class="form-label">Localidad</label>
              <input type="text" class="form-control" v-model="perfil.ciudad">
            </div>
            <div class="col-6 mb-3">
              <label class="form-label">Código Postal</label>
              <input type="text" class="form-control" v-model="perfil.codigo_postal">
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Provincia</label>
            <select class="form-select" v-model="perfil.provincia_id">
              <option v-for="provincias in listadosEntidadesStore.provincias" :key="provincias.id"
                :value="provincias.id"> 
                {{ provincias.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Botones -->
      <div class="d-flex justify-content-end mt-4">
        <button class="btn btn-light me-2" disabled>Cancelar</button>
        <button class="btn btn-primary">Guardar</button>
      </div>
    </div>
  </div>
</template>


<style scoped>
/* Fondo de la página */
body {
  background-color: #f8f9fa;
}

/* Avatar con icono */
.avatar-container {
  position: relative;
  display: inline-block;
}

.avatar {
  width: 80px;
  height: 80px;
  font-size: 24px;
}

.avatar-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  font-size: 14px;
}
</style>
